import "babel-polyfill";
import "core-js/es6/map";
import "core-js/es6/set";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { Provider, connect } from "react-redux";
import PropTypes from "prop-types";
import Ajax from "Pub/js/ajax";
import { getMulti } from "Pub/js/getMulti";
import { initAppData, setThemeColor } from "Store/appStore/action";
import store from "./store";
import Routes from "./routes";
import Notice from "Components/Notice";
import dayjs from "dayjs";
import { openApp, openPage, commontOpenNewWindow, ownPageAppcodes } from "Pub/js/superJump";
import Browser from 'Pub/js/browser';
import { setStore, getStore } from "Pub/js/storageUtils";
import { langCheck, generateUrlKey, getWindow, DEFAULT_LOGOUT_URL, setBodyClass, setWorkbenchTheme, urlAddParams, updateDimenMap } from "Pub/js/utils";
import "dayjs/locale/zh-cn";
import "Assets/iconfont/iconfont.js";
import appIconSet from "Pub/js/appIconSet";
import platform from "Pub/js/platform";
import { MYAPPINFO, NOTMYAPP, MYCOLLECT, RECENTVISIT } from "Pub/js/allApps";
import "Pub/css/public.less";
import "Assets/css/workbench-font.less";
import "./theme/theme.less";
const { ajax, getLangCode } = platform;
dayjs.locale('zh-cn');
function setWindowName() {
    let search = window.location.href.split('?')[1];
    search = search ? search.split('&') : [];
    let params = {};
    search.forEach(el => {
        let [key, value] = el.split('=');
        if (key) {
            params[key] = decodeURIComponent(value);
        }
    });
    if (!window.name) {
        if (params.page) {
            window.name = params.page;
        }
        if (params.workbenchid) { // 这个留着兼容别的地方只传这个的
            window.name = params.workbenchid;
        }
        if (params.windowName) { // 强制传windowName的（目前工作台设计和预览都采用了这种方式）
            window.name = params.windowName;
        }
    }
}
function compatLocalStorageInEdgeInPrivateMode() {
    let browser = Browser();
    let winOpener = window.opener;
    let lsKeys;
    if (browser === 'Edge' && !window.indexedDB && winOpener && !getStore('cowboy')) {
        // Edge is Inprivate mode in windows system && is opened sub page tab && cowboy not exist
        lsKeys = Object.keys(winOpener.localStorage);
        lsKeys.forEach(key => {
            setStore(key, winOpener.localStorage.getItem(key));
        });
    }
}

function initWindow() {
    window.openWorkbenchPage = openPage; // 打开工作桌面内部页面方法
    window.CURRENT_LANG_CODE = getLangCode(); // 把当前语种存起来
    const crossTabData = getStore('AppCrossTabData');
    if (crossTabData) {
        window.AppCrossTabData = crossTabData;
        localStorage.removeItem('AppCrossTabData');
    }
}

class App extends Component {
    constructor(props) {
        if (!Object.fromEntries) { // 兼容低版本浏览器
            Object.fromEntries = val => val.reduce((res, item) => { return Object.assign(res, { [item[0]]: item[1] }); }, {});
        }
        super(props);
        this.state = { isLoaded: false };
        initWindow();
        setWindowName();
        compatLocalStorageInEdgeInPrivateMode();

        let browser = Browser();
        if (browser === 'IE') {
            window.onload = () => {
                //获取sessionStorage，决定是否是新的会话以初始化localStorage
                let sessionCnt = sessionStorage.getItem('ieTabCnt');
                if (!sessionCnt || sessionCnt < 1) {
                    //初始化sessionStorage和localStorage
                    sessionStorage.setItem('ieTabCnt', 1);
                    localStorage.setItem('ieTabCnt', 1);
                } else {
                    //页签数量+1
                    let lastCnt = Number.parseInt(localStorage.getItem('ieTabCnt'));
                    localStorage.setItem('ieTabCnt', lastCnt + 1);
                }
            };
            window.onunload = () => {
                //页面刷新or关闭，页签数量-1
                let lastCnt = Number.parseInt(localStorage.getItem('ieTabCnt'));
                localStorage.setItem('ieTabCnt', lastCnt - 1);
            };
        }
    }

    getUrlPageParam = () => {
        let urlParamArr = window.location.href.split('?');
        //无参数或无?匹配
        if (!urlParamArr || urlParamArr.length < 2) {
            return null;
        }

        let paramPair = urlParamArr[1].split('page=');
        //无page参数
        if (!paramPair || paramPair.length < 2) {
            return null;
        }

        //有多个参数或无多个参数，均可获取最终page的值
        return paramPair[1].split('&')[0];
    }
    // 处理最近访问传接口数据
    handleRecentData = appOption => {
        // 兼容 window.openNew 传入数据不一致
        return {
            label: appOption.label || appOption.name || appOption.menu,
            appcode: appOption.appcode,
            appid: appOption.appid,
            is_cloud_app: appOption.is_cloud_app,
            image_src: appOption.image_src,
            menuitemid: appOption.menuitemid || appOption.cardid || appOption.value,
            menuitemcode: appOption.menuitemcode || appOption.code,
        };
    }
    //存储最近访问
    addRencent = appOption => {
        const recentData = this.handleRecentData(appOption);
        Ajax({
            url: "/nccloud/platform/appregister/addrecentvisit.do",
            data: recentData,
            info: {
                name: langCheck("0000PUB-000276") /* 国际化处理： 最近访问*/,
                action: langCheck("0000PUB-000316"), /* 国际化处理： 存储最近访问*/
            },
            success: ({ data }) => {
                console.log(data);
            },
            error: error => {
                console.log(error);
            },
        });
    }
    /**
     * 打开应用
     * @param {Object} appOption - 应用对象
     * @param {String} type - 打开类型 current - 当前页面打开
     * @param {String} query - 需要传递的参数
     * @param {Boolean} openTabWithoutCheck = 强制使用新窗口打开页面 默认false
     * @param {Function} mapDataFn =处理返回的数据
     */
    openNewApp = (appOption, type, query, {
        openTabWithoutCheck,
        mapDataFn,
        jumpUrl,
        targetPagecode,
        urlParams, // 格式 a=1&b=2
        pageParams = {}, // 格式 {modalTitle: '', hideNav: true}
        recordRecent,
        funcParams,
    } = {}) => {
        let win = window;
        let { appcode, menuitemcode, name, is_cloud_app, queryParameters, pagecode } = appOption;
        let ajaxPromise = function(){
            return new Promise((resolve)=>{
                let cacheKey = appcode + '_' + pagecode + '_' + menuitemcode;
                let cacheData = getStore('cache_openapp_data') || {};
                // 计算当天0点的时间戳  
                const todayStart = new Date(new Date().setUTCHours(0, 0, 0, 0)).getTime(); 
                let cacheTs = 0;
                if(cacheData[cacheKey] && cacheData[cacheKey].ts){
                    cacheTs = Number(cacheData[cacheKey].ts)
                }
                //第二次打开节点，且缓存为当天0点后缓存，则使用缓存数据
                if( window.record_spa_app && window.record_spa_app[cacheKey] && cacheTs > todayStart ){
                    let data = cacheData[cacheKey].data;
                    //走缓存数据的时候，再发送一个异步的请求，为了上机日志功能 YBP-CCF-BUG-1245
                    Ajax({
                        url: `/nccloud/platform/appregister/openapp.do`,
                        info: {
                            name: name,
                            action: langCheck("0000PUB-000087"), //国际化处理: 权限校验
                            appcode: 10228888,
                        },
                        data: {
                            appcode,
                            is_cloud_app,
                            pagecode, // 快速发起需要具体到页面
                            menucode: menuitemcode,
                            menuitemid: appOption.menuitemid || appOption.cardid || appOption.value 
                        },
                        success: ({ data: { data } }) => {
                        },
                    });
                    resolve(data);
                }else{//否则是第一次打开或者缓存失效，则重新请求并更新缓存
                    if (!window.record_spa_app) {
                        window.record_spa_app = {};
                    }
                    window.record_spa_app[cacheKey] = true;
                    Ajax({
                        url: `/nccloud/platform/appregister/openapp.do`,
                        info: {
                            name: name,
                            action: langCheck("0000PUB-000087"), //国际化处理: 权限校验
                            appcode: 10228888,
                        },
                        loading: true,
                        data: {
                            appcode,
                            is_cloud_app,
                            pagecode, // 快速发起需要具体到页面
                            menucode: menuitemcode,
                            menuitemid: appOption.menuitemid || appOption.cardid || appOption.value 
                        },
                        success: ({ data: { data } }) => {
                            if (data) {
                                if(!cacheData){
                                    cacheData = {};
                                }
                                if(!cacheData[cacheKey]){
                                    cacheData[cacheKey] = {};
                                }
                                cacheData[cacheKey].data = data;
                                cacheData[cacheKey].ts = Date.now(); 
                                try {
                                    setStore('cache_openapp_data', cacheData);
                                } catch (e) {
                                    console.log(e);
                                }
                                resolve(data);   
                            }
                        },
                    });
                }
            })
        }
        ajaxPromise().then((data)=>{
            // NCC-70932 客户特殊需求，小应用节点面包屑需要移仓层级结构，
            // 这不符合小应用原先的规则，所以需要扩展一个处理返回数据的方法，支持该需求
            let { tabConfig = {} } = funcParams;
            if (typeof mapDataFn === 'function') {
                data = mapDataFn(data);
            } else if (mapDataFn && typeof mapDataFn === 'object') {
                data = { ...data, ...mapDataFn };
                tabConfig.mapDataFn = mapDataFn;
            }

            // 指定跳转页面
            if (jumpUrl) {
                data.pageurl = jumpUrl;
            }

            if (!this.handleAppData(appcode, data, true)) {
                return;
            }

            if (urlParams) {
                data.pageurl = urlAddParams(data.pageurl, urlParams);
            }
                // recordRecent && this.addRencent({ ...appOption, ...data });
                // 打开应用
                window.proxyAction && window.proxyAction(
                    openApp,
                    this,
                    langCheck("0000PUB-000088"),
                )(
                    //打开应用
                    win,
                    appcode,
                    data.appid,
                    targetPagecode || data.pagecode,
                    type,
                    query,
                    data,
                    openTabWithoutCheck,
                    queryParameters,
                    { ...pageParams },
                    { ...funcParams, tabConfig },
                );
                window.startAjax && window.startAjax(); //记录应用打开时间
                window.endAjax && window.endAjax(); //记录应用打开时间
        });
    };

    handleAppData = (appcode, data, openByMenu = false) => {
        if (!data) { return; }
        const { pageurl, tabmode, dimenMap, appParams = {} } = data;

        if (!data.is_haspower) { // 无权限
            Notice({
                status: "error",
                msg: data.hint_message,
            });
            return;
        }

        if (openByMenu && !pageurl) {
            Notice({
                status: "error",
                msg: langCheck("0000PUB-000089"), // 请确认当前应用是否设置默认页面！
            });
            return;
        }

        if (data.is_cloud_app) { // 云应用
            const cloudWin = window.open(pageurl);
            return;
        }

        window.currentMicroAppType = tabmode;
        if (!ownPageAppcodes.includes(appcode) && /^\/|^..\//.test(pageurl)) {
            data.pageurl = this.dealWithUrl(pageurl);
        }
        updateDimenMap(appcode, dimenMap);

        // 不需要统一水印的节点
        const noWatermarkApps = getStore('noWatermarkApps') || [];
        if (appParams.enableReportWaterMark === 'Y') {
            noWatermarkApps.push(appcode);
        } else {
            _.remove(noWatermarkApps, item => item === appcode);
        }
        setStore('noWatermarkApps', noWatermarkApps);

        // 设置当前打开小应用的图标 供业务单据使用
        appIconSet(appcode, data.image_src);
        // 应用菜单名
        window.peData.nodeName = data.menu;
        // 应用编码
        window.peData.nodeCode = appcode;
        // 用户id  由于需要知道具体哪个人所以将userid字段改成userCode 此处需要注意
        window.peData.userID = this.props.userCode;
        // 项目编码
        window.peData.projectCode = this.props.projectCode;
        // pe 地址
        window.peData.nlinkUrl = this.props.nlinkUrl;

        return true;
    }

    // 处理pageurl
    dealWithUrl(pageurl) {
        if (!pageurl.includes('html')) { // 兼容
            // ../../../../low_code_designer/low-code/clay/main/#/preview
            const defaultHtml = 'index.html'; // 默认入口文件
            // 以#分割，前面的是path
            const pageArr = pageurl.split('#');
            pageArr[0] += pageArr[0].endsWith('/') ? defaultHtml : `/${defaultHtml}`;
            pageurl = pageArr.join('#');
        }
        // 正则匹配区分 path地址，hash值，params参数 部分
        // /ncchr/index.html#/pm/program
        // ../../../../sca/workbench/costconvtask/main/index.html#list
        // ../../../../gl/vouTypeRule/pages/list/index.html#nodeType=global
        // ../../../../epmp/epm_p/consolidatedRulem/list/index.html?busisys=BCS
        const urlArr = [...pageurl.match(/(.*html)(#\/[^?&]*|#?)(.*)/)];
        urlArr.shift();
        if (!/=/.test(urlArr[2])) { // 误将路由认成了参数的key，修复（例：a.html#b）
            urlArr[1] += urlArr[2];
            urlArr[2] = '';
        }
        // urlArr [path, hash, params]
        urlArr[0] += `?t=${Date.now()}`; // html加时间戳避免缓存问题
        // 处理hash
        const defaultHash = '#/';
        if (!urlArr[1]) {
            urlArr[1] = defaultHash;
        } else {
            if (urlArr[1].startsWith('#') && urlArr[1][1] !== '/') {
                urlArr[1] = urlArr[1].replace('#', defaultHash)
            }
        }
        // 处理params
        if (urlArr[2]) {
            if (!urlArr[2].startsWith('?')) {
                if (urlArr[2].startsWith('&')) {
                    urlArr[2] = urlArr[2].replace('&', '?');
                } else {
                    urlArr[2] = `?${urlArr[2]}`;
                }
            }
        }

        return urlArr.join('');
    }

    componentWillMount() {
        getMulti({
            moduleId: "0000PUB",
            domainName: "workbench",
            callback: json => {
                window.multiLang = json;
                this.setState({ isLoaded: true });
            },
        });
        /**
         * 为spr统计提供基本信息
         */
        window.peData = {};
        /**
         * 在新页签中打开
         * @param   {String} isMyApp // 是否为 我的应用 里的点击 0 普通 1 我的收藏 2 最近访问
         * @param　{Object} appOption // 应用 描述信息 name 、 appcode、menuitemcode、is_cloud_app
         * @param　{String} type // current - 浏览器新页签打开 不传参数在当前页打开
         * @param {String} query - 需要传递的参数 需要字符串拼接 如 &a=1&b=2（这个参数不要乱用，我看到有领域是取这个参数给小友机器人使的）
         * @param    {Boolean} openTabWithoutCheck --强制使用新窗口打开页面 默认false
         * @param   {Function} mapDataFn // 处理openapp.do返回的数据 
         * 
         */
        window.openNew = (appOption, type, query, params = {}) => {
            const {
                openTabWithoutCheck = false,
                mapDataFn,
                isSetKnowledge = true,
                isMyApp,
                targetPagecode, //目标页面pagecode
                urlParams, // 目标页面pageUrl的参数
                pageParams, // 用于workbench自己用的，解析需要的参数
                recordRecent = true, // 记录最近访问
                funcParams = {}, // 给函数用于判断业务逻辑的参数
            } = params;
            if (typeof appOption === "object") {
                const jumpUrl = (funcParams.isQuickAdd && appOption.fastlaunchurl) || ''; // 快速发起-新增打开
                this.openNewApp(appOption, type, query, {
                    openTabWithoutCheck,
                    mapDataFn,
                    jumpUrl,
                    targetPagecode,
                    urlParams,
                    pageParams,
                    recordRecent,
                    funcParams,
                });
                if (isMyApp === 1) {
                    setStore(MYAPPINFO, {
                        b1: langCheck("0000PUB-000552") /* 国际化处理： 我的应用*/,
                        b2: '',
                        b3: langCheck("0000PUB-000404") /* 国际化处理： 我的收藏*/,
                        n: appOption.label,
                        value: MYCOLLECT,
                    });
                } else if (isMyApp === 2) {
                    setStore(MYAPPINFO, {
                        b1: langCheck("0000PUB-000552") /* 国际化处理： 我的应用*/,
                        b2: '',
                        b3: langCheck("0000PUB-000342") /* 国际化处理： 最近访问*/,
                        n: appOption.label,
                        value: RECENTVISIT,
                    });
                } else {
                    //  key 是表明点击的  不是默认设置的
                    setStore(MYAPPINFO, { value: NOTMYAPP, key: 1 });
                }
                // 存取知识条目
                if (isSetKnowledge) {
                    setStore("knowledgeApp", { appcode: appOption.appcode, appid: appOption.appid });
                }
            }
        };

        /**
         * 跳转检查 （ 占用 license ）
         * 调用此方法去修改URL地址时需要encodeURIComponent两次
         * 获取URL参数时需要decodeURIComponent两次
         * @param {String|undefined|null} appcode - 应用编码 值为""/undefined/null 则不会校验权限  需要工作台容器
         * @param {String|undefined|null} pagecode - 页面编码编码 值为""/undefined/null 则返回应用默认页面
         * @param {Function} callback - 检查之后的回调
         * @param {String} tab - 新页签
         */
        window.openCheck = (appcode, pagecode, callback, type, { crossTabData, menucode, toastContainer, isSkipPower } = {}) => {
            let win = window;
            let href = getLocation(getWindow()).href;
            // 需要校验权限
            if (appcode && appcode.length) {
                //为了解决Firefox异步打开新页签会重定向问题，改为使用platform的ajax
                ajax({
                    url: `/nccloud/platform/appregister/openapp.do`,
                    // sysParameter: {
                    //     appcode: 10228888,
                    //     busiaction: `${langCheck("0000PUB-000086")}-${langCheck(
                    //         "0000PUB-000087"
                    //     )}` /* 国际化处理： 工作桌面-权限校验*/,
                    //     ts: new Date().getTime(),
                    //     pagecs: cookiets
                    // },
                    sysAppcode: 10228888,
                    data: {
                        appcode,
                        pagecode,
                        menucode,
                        isSkipPower
                    },
                    async: false,
                    toastContainer,
                    success: data => {
                        if (!this.handleAppData(appcode, data.data)) {
                            return;
                        }
                        
                        /**
                         * 校验回调
                         * @param {Object} win - 窗口对象
                         * @param {Object} data - 检验之后的参数
                         */
                        window.proxyAction && window.proxyAction(
                            callback,
                            this,
                            langCheck("0000PUB-000088"),
                        )(win, data, (newUrl, openParams) => {
                            if (newUrl) {
                                const baseHref = href.split('#')[0];
                                let newHref = baseHref + newUrl;
                                if (ownPageAppcodes.includes(appcode)) {
                                    newHref = `${baseHref}${newUrl.replace('ifr', data.data.pageurl)}`;
                                }
                                this.openNewTab({
                                    win,
                                    href: newHref,
                                    type,
                                    appcode,
                                    pagecode: pagecode || data.data.pagecode,
                                    menucode,
                                    crossTabData,
                                    openParams
                                })
                            }
                        });
                    },
                });
            } else {
                // 不需要校验跳转权限且需要工作台容器
                /**
                 * 校验回调
                 * @param {Object} win - 窗口对象
                 */
                callback(win);
            }
        };

        /**
         * 跳转检查 （不占用 license）
         * 参数及注意 同 window.openCheck 方法
         */
        window.specialOpenCheck = (appcode, pagecode, callback, type, { toastContainer } = {}) => {
            let win = window;

            let href = getLocation(getWindow()).href;
            // 需要校验权限
            if (appcode && appcode.length) {
                //为了解决Firefox异步打开新页签会重定向问题，改为使用platform的ajax
                ajax({
                    url: `/nccloud/platform/appregister/openapp2.do`,
                    // sysParameter: {
                    //     appcode: 10228888,
                    //     busiaction: `${langCheck("0000PUB-000086")}-${langCheck(
                    //         "0000PUB-000087"
                    //     )}` /* 国际化处理： 工作桌面-权限校验*/,
                    //     ts: new Date().getTime(),
                    //     pagecs: cookiets
                    // },
                    sysAppcode: 10228888,
                    data: {
                        appcode,
                        pagecode,
                    },
                    async: false,
                    toastContainer,
                    success: data => {
                        if (!this.handleAppData(appcode, data.data)) {
                            return;
                        }
                        
                        /**
                         * 校验回调
                         * @param {Object} win - 窗口对象
                         * @param {Object} data - 检验之后的参数
                         */
                        window.proxyAction && window.proxyAction(
                            callback,
                            this,
                            langCheck("0000PUB-000088"),
                        )(win, data, (newUrl, openParams) => {
                            if (newUrl) {
                                let newHref = href.split('#')[0] + newUrl;
                                this.openNewTab({
                                    win,
                                    href: newHref,
                                    type,
                                    appcode,
                                    pagecode: pagecode || data.data.pagecode,
                                    openParams
                                })
                            }
                        });
                    },
                });
            } else {
                // 不需要校验跳转权限且需要工作台容器
                /**
                 * 校验回调
                 * @param {Object} win - 窗口对象
                 */
                callback(win);
            }
        };

        //注销
        window.logout = () => {
            window.proxyAction &&
                window.proxyAction(
                    logout,
                    this,
                    langCheck("0000PUB-000140"),
                )({ logout: true }); /* 国际化处理： 注销*/

            function logout() {
                Ajax({
                    url: `/nccloud/riart/login/logout.do`,
                    info: {
                        name: langCheck("0000PUB-000109") /* 国际化处理： 工作桌面*/,
                        appcode: "10228888",
                        action: langCheck("0000PUB-000140"), /* 国际化处理： 注销*/
                    },
                    success: ({ data: { data } }) => {
                        const { diworkUrl, logoutRedict } = data;
                        diworkUrl && logoutDiworkIframe(diworkUrl);
                        localStorage.removeItem("cowboy"); // 登出的时候清理一下aeskey cowboy by bbqin
                        sessionStorage.removeItem("gzip");
                        localStorage.removeItem("NCC_IMData");
                        getWindow().location.href = logoutRedict || DEFAULT_LOGOUT_URL;
                    },
                });
            }

            //注销diwork
            function logoutDiworkIframe(url) {
                let logoutIframe = document.createElement("iframe");
                logoutIframe.setAttribute("src", url);
                logoutIframe.style.width = "1px";
                logoutIframe.style.height = "1px";
                logoutIframe.frameBorder = "0";
                logoutIframe.scrolling = "no";
                document.body.appendChild(logoutIframe);
            }
        };

        // 更新工作桌面主题
        // theme { type, name, color, pk_customtheme }
        window.updateWorkbenchTheme = theme => {
            this.props.setThemeColor(theme); // 设置 store主题色
            const { type, color } = theme;
            setWorkbenchTheme(type, color);
            // 更换body class
            setBodyClass({ themeType: type });
            window.nccColor = type;
        };
    }
    componentDidMount() {
        // 模拟数据，应该在此处进行数据请求，返回用户初始信息
        let data = { lang: "zh-CN" };
        this.props.initAppData(data);
    }

    // openParams 目前是内部页签模式下linkto时将tabKey传过来，为了更新指定页签承载的微应用
    openNewTab = ({ win, href, type, appcode, pagecode, menucode, crossTabData, openParams = {} }) => {
        let urlKey = href.split('page=').pop();
        if (type === 'switch') {
            urlKey = generateUrlKey({ appcode, pagecode, menucode });
        }
        if (type === '') {
            type = 'link';
        }

        commontOpenNewWindow(win, href, urlKey, type, crossTabData, false, openParams);
    }

    render() {
        let { isLoaded } = this.state;
        return isLoaded ? <Routes rootInstance={this} /> : null;
    }
}
App.propTypes = {
    nlinkUrl: PropTypes.string.isRequired,
    userCode: PropTypes.string.isRequired,
    projectCode: PropTypes.string.isRequired,
    initAppData: PropTypes.func.isRequired,
};
const AppStore = connect(
    state => ({
        nlinkUrl: state.appData.nlinkUrl,
        userCode: state.appData.userCode,
        projectCode: state.appData.projectCode,
    }),
    {
        initAppData,
        setThemeColor,
    },
)(App);
ReactDOM.render(
    <Provider store={store}>
        <AppStore />
    </Provider>,
    document.querySelector("#app"),
);

function getLocation(win) {
    return win.location;
}